'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _sharedJacketCover = require('@bibliocommons/shared-jacket-cover');

var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);

var _BibItemInfo = require('../../bib-item-info/components/BibItemInfo.component');

var _BibItemInfo2 = _interopRequireDefault(_BibItemInfo);

require('../styles/CatalogueResults.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getJacketCoverSrc(briefInfo) {
  var jacket = briefInfo ? briefInfo.get('jacket') : _immutable2.default.Map();

  return _immutable2.default.Map({
    small: jacket.get('small'),
    medium: jacket.get('medium'),
    large: jacket.get('large'),
    local_url: jacket.get('local_url'),
    type: jacket.get('type')
  });
}

var CatalogueResults = function (_BcReactComponent) {
  _inherits(CatalogueResults, _BcReactComponent);

  function CatalogueResults(props) {
    _classCallCheck(this, CatalogueResults);

    var _this = _possibleConstructorReturn(this, (CatalogueResults.__proto__ || Object.getPrototypeOf(CatalogueResults)).call(this, props));

    _this.bindAll('focusOnTitle');
    return _this;
  }

  _createClass(CatalogueResults, [{
    key: 'focusOnTitle',
    value: function focusOnTitle() {
      if (this._bibItemInfo) {
        this._bibItemInfo.focusOnTitle();
      }
    }
  }, {
    key: 'renderAddOn',
    value: function renderAddOn(briefInfo) {
      if (this.props.renderAddOn) {
        return this.props.renderAddOn(briefInfo);
      }

      return null;
    }
  }, {
    key: 'renderItem',
    value: function renderItem(bib) {
      var _this2 = this;

      var availabilityDetailActions = this.props.availabilityDetailActions;

      var briefInfo = bib.get('briefInfo');

      return _react2.default.createElement(
        'div',
        { className: 'catalogue-results-search-result-item' },
        _react2.default.createElement(
          'div',
          { className: 'search-result-contents' },
          _react2.default.createElement(
            'div',
            { className: 'item-inner-content' },
            _react2.default.createElement(
              'div',
              { className: 'jacket-wrapper' },
              _react2.default.createElement(_sharedJacketCover2.default, {
                alt: '',
                format: briefInfo.get('format'),
                src: getJacketCoverSrc(briefInfo),
                size: 'small' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'info-content' },
              _react2.default.createElement(_BibItemInfo2.default, {
                showAvailability: true,
                bib: bib,
                ref: function ref(el) {
                  return _this2._bibItemInfo = el;
                },
                availabilityDetailActions: availabilityDetailActions,
                compact: true }),
              this.renderAddOn(briefInfo)
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          searchResults = _props.searchResults,
          addRowClassNames = _props.addRowClassNames;


      return _react2.default.createElement(
        'div',
        { className: 'cp-catalogue-results' },
        _react2.default.createElement(
          'ul',
          { className: 'search-results-list' },
          searchResults.map(function (item, i) {
            return _react2.default.createElement(
              'li',
              { key: i, className: (0, _classnames2.default)('search-results-row', addRowClassNames(item)) },
              _this3.renderItem(item)
            );
          })
        )
      );
    }
  }]);

  return CatalogueResults;
}(_baseBcReactComponent2.default);

CatalogueResults.propTypes = {
  searchResults: _reactImmutableProptypes2.default.listOf(_bcPropTypes.bibShape),
  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
  addRowClassNames: _react.PropTypes.func,
  renderAddOn: _react.PropTypes.func
};

CatalogueResults.defaultProps = {
  addRowClassNames: function addRowClassNames() {}
};

exports.default = CatalogueResults;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/catalogue-results/components/catalogue-results/components/CatalogueResults.component.js
// module id = 980
// module chunks = 1